import React from 'react';
import moment from 'jalali-moment';
import Style from '../reserve/__reserve.module.css';

/*
    - ihoDesignSystem
*/
import { Dropdown, Badge, Box, Button, Grid, Image, Modal, Select, TextField, Tooltip, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import ChevronDownSVG from '../../assets/images/icons/chevron-down.svg';
import EmptySVG from '../../assets/images/icons/empty.svg';
import ObserverSVG from '../../assets/images/icons/observer.svg';
import VerticalDotsSVG from '../../assets/images/icons/vertical-dots.svg';
import PaginationRightSVG from '../../assets/images/icons/pagination-right.svg';
import PaginationLeftSVG from '../../assets/images/icons/pagination-left.svg';
import InfoBlueSVG from '../../assets/images/icons/info-blue.svg';
import InfoDarkSVG from '../../assets/images/icons/info-dark.svg';
import LoadingCustomSVG from '../../assets/images/icons/loading-custom.svg';

/*
    - api
*/
import invoicePdfAPI from '../../api/get/InvoicePdf';
import voucherPdfAPI from '../../api/get/VoucherPdf';
import addOfficialInvoiceAPI from '../../api/add/OfficialInvoice';
import officalInvoiceAPI from '../../api/get/OfficialInvoice';

const List = ({ props, alertProps, paginationProps, reloadReserveProps }) => {

    /*
        - defaultData
    */
    const [reserves, setReserves] = React.useState('loading');
    const [userCompaniesHistory, setUserCompaniesHistory] = React.useState('empty');
    const [activeTab, setActiveTab] = React.useState(['bg-gray-light', 'bg-white']);
    const [tabType, setTabType] = React.useState('naturalPerson');
    const [selectedReserve, setSelectedReserve] = React.useState('');
    const [addOfficialInvoiceParameters, setAddOfficialInvoiceParameters] = React.useState({
        name: {
            value: '',
            color: 'dark'
        },
        ecoNum: {
            value: '',
            color: 'dark'
        },
        codeMelli: {
            value: '',
            color: 'dark'
        },
        regNum: {
            value: '',
            color: 'dark'
        },
        tel: {
            value: '',
            color: 'dark'
        },
        mobile: {
            value: '',
            color: 'dark'
        },
        postalCode: {
            value: '',
            color: 'dark'
        },
        companyAddress: {
            value: '',
            color: 'dark'
        },
        postAddress: {
            value: '',
            color: 'dark'
        }
    });

    React.useEffect(() => {
        if (props.reserves !== '') {
            if (props.reserves.status === 200 && props.reserves.data.Data.length > 0) {
                setReserves(props.reserves.data);
            } else {
                setReserves('empty');
            }
        }
        if (props.userCompaniesHistory.status === 200 && props.userCompaniesHistory.data.length > 0) {
            setUserCompaniesHistory(props.userCompaniesHistory.data);
        } else {
            setUserCompaniesHistory([]);
        }
    }, [props]);

    /*
        - addaddOfficialInvoiceHandler
    */
    const addOfficialInvoiceHandler = (key, value) => {
        if (key === 'name' && value !== '' && /^[آ-ی ]+$/.test(value)) {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                name: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'name') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                name: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'ecoNum' && value !== '') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                ecoNum: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'ecoNum') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                ecoNum: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'codeMelli' && value !== '') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                codeMelli: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'codeMelli') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                codeMelli: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'regNum' && value !== '') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                regNum: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'regNum') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                regNum: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'tel' && value !== '' && /^[\u06F0-\u06F90-9]+$/.test(value)) {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                tel: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'tel') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                tel: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'mobile' && value.length === 11 && /^[\u06F0-\u06F90-9]+$/.test(value)) {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                mobile: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'mobile') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                mobile: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'postalCode' && value.length === 10 && /^[\u06F0-\u06F90-9]+$/.test(value)) {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                postalCode: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'postalCode') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                postalCode: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'companyAddress' && value !== '') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                companyAddress: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'companyAddress') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                companyAddress: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'postAddress' && value !== '') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                postAddress: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'postAddress') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                postAddress: {
                    value: value,
                    color: 'danger'
                }
            });
        }
    }

    /*
        - addOfficialInvoice
    */
    const addOfficialInvoice = async () => {
        let parameters = {};
        let isValid = 1;
        if (addOfficialInvoiceParameters.name.value === '' || !/^[آ-ی ]+$/.test(addOfficialInvoiceParameters.name.value)) {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                name: {
                    value: addOfficialInvoiceParameters.name.value,
                    color: 'danger'
                }
            });
            isValid = 0
        }
        if (addOfficialInvoiceParameters.codeMelli.value === '') {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                codeMelli: {
                    value: addOfficialInvoiceParameters.codeMelli.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addOfficialInvoiceParameters.tel.value.length === '' || !/^[\u06F0-\u06F90-9]+$/.test(addOfficialInvoiceParameters.tel.value)) {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                tel: {
                    value: addOfficialInvoiceParameters.tel.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addOfficialInvoiceParameters.mobile.value.length !== 11 || !/^[\u06F0-\u06F90-9]+$/.test(addOfficialInvoiceParameters.mobile.value)) {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                mobile: {
                    value: addOfficialInvoiceParameters.mobile.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addOfficialInvoiceParameters.postalCode.value.length !== 10 || !/^[\u06F0-\u06F90-9]+$/.test(addOfficialInvoiceParameters.postalCode.value)) {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                postalCode: {
                    value: addOfficialInvoiceParameters.postalCode.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addOfficialInvoiceParameters.postAddress.value.length === 0) {
            setAddOfficialInvoiceParameters({
                ...addOfficialInvoiceParameters,
                postAddress: {
                    value: addOfficialInvoiceParameters.postAddress.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (isValid === 1) {
            parameters.reserveId = selectedReserve.ReserveId;
            parameters.Name = addOfficialInvoiceParameters.name.value;
            parameters.EcoNum = addOfficialInvoiceParameters.ecoNum.value;
            parameters.CodeMelli = addOfficialInvoiceParameters.codeMelli.value;
            parameters.RegNum = addOfficialInvoiceParameters.regNum.value;
            parameters.Tel = addOfficialInvoiceParameters.tel.value;
            parameters.Mobile = addOfficialInvoiceParameters.mobile.value;
            parameters.PostalCode = addOfficialInvoiceParameters.postalCode.value;
            parameters.CompanyAddress = addOfficialInvoiceParameters.companyAddress.value;
            parameters.PostAddress = addOfficialInvoiceParameters.postAddress.value;
            let result = await addOfficialInvoiceAPI(parameters);
            if (result === 'success') {
                setAddOfficialInvoiceParameters({
                    name: {
                        value: '',
                        color: 'dark'
                    },
                    ecoNum: {
                        value: '',
                        color: 'dark'
                    },
                    codeMelli: {
                        value: '',
                        color: 'dark'
                    },
                    regNum: {
                        value: '',
                        color: 'dark'
                    },
                    tel: {
                        value: '',
                        color: 'dark'
                    },
                    mobile: {
                        value: '',
                        color: 'dark'
                    },
                    postalCode: {
                        value: '',
                        color: 'dark'
                    },
                    companyAddress: {
                        value: '',
                        color: 'dark'
                    },
                    postAddress: {
                        value: '',
                        color: 'dark'
                    }
                });
                closeModal('officalInvoice');
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadReserveProps(Math.floor(Math.random() * 100));
            } else {
                alertProps(['danger', 'خطایی رخ داده است']);
            }
        }
    }

    /*
        - officalInvoice
    */
    const officalInvoice = async (nuRequest) => {
        let parameters = {};
        parameters.reserveId = nuRequest;
        await officalInvoiceAPI(parameters);
    }

    /*
        - downloadLink
    */
    const downloadLink = async (type, ReserveId) => {
        let parameters = {};
        parameters.reserveId = ReserveId;
        if (type === 'invoice') {
            await invoicePdfAPI(parameters);
        }
        if (type === 'voucher') {
            await voucherPdfAPI(parameters);
        }
    }

    /*
        - reserveSource
    */
    const reserveSource = (ReserveId) => {
        window.open(`/persian/pursuit/reserveRespond/${ReserveId}`, '_blank');
    }

    /*
        - setUserCompaniesHistory
    */
    const autoFillOfficialInvoice = (selcteduserCompaniesHistory) => {
        userCompaniesHistory.forEach((obj) => {
            if (obj.Name === selcteduserCompaniesHistory) {
                setAddOfficialInvoiceParameters({
                    name: {
                        value: obj.Name,
                        color: 'dark'
                    },
                    ecoNum: {
                        value: obj.EcoNum,
                        color: 'dark'
                    },
                    codeMelli: {
                        value: obj.Codemelli,
                        color: 'dark'
                    },
                    regNum: {
                        value: obj.RegNum,
                        color: 'dark'
                    },
                    tel: {
                        value: obj.Tel,
                        color: 'dark'
                    },
                    mobile: {
                        value: obj.Mobile,
                        color: 'dark'
                    },
                    postalCode: {
                        value: obj.PostalCode,
                        color: 'dark'
                    },
                    companyAddress: {
                        value: obj.CompanyAddress,
                        color: 'dark'
                    },
                    postAddress: {
                        value: obj.PostAddress,
                        color: 'dark'
                    }
                });
            }
        });
    }

    /*
        - extraInfoToggle
    */
    const extraInfoToggle = (event) => {
        let slideUp = event.target.closest('.parent-class').querySelector('.slide-up');
        let slideDown = event.target.closest('.parent-class').querySelector('.slide-down');
        if (slideUp) {
            slideUp.classList.add(`slide-down`);
            slideUp.classList.remove(`slide-up`);
        }
        if (slideDown) {
            slideDown.classList.add(`slide-up`);
            slideDown.classList.remove(`slide-down`);
        }
    }

    /*
        - toggleTab
    */
    const toggleTab = (nationality) => {
        setAddOfficialInvoiceParameters({
            name: {
                value: '',
                color: 'dark'
            },
            ecoNum: {
                value: '',
                color: 'dark'
            },
            codeMelli: {
                value: '',
                color: 'dark'
            },
            regNum: {
                value: '',
                color: 'dark'
            },
            tel: {
                value: '',
                color: 'dark'
            },
            mobile: {
                value: '',
                color: 'dark'
            },
            postalCode: {
                value: '',
                color: 'dark'
            },
            companyAddress: {
                value: '',
                color: 'dark'
            },
            postAddress: {
                value: '',
                color: 'dark'
            }
        });
        if (nationality === false) {
            setActiveTab(['bg-gray-light', 'bg-white']);
            setTabType('naturalPerson');
        }
        if (nationality === true) {
            setActiveTab(['bg-white', 'bg-gray-light']);
            setTabType('legalPerson');
        }
    }

    /*
        - modal
    */
    const openModal = (modal, selectedReserve) => {
        setSelectedReserve(selectedReserve);
        document.querySelector(`.${modal}`).classList.remove('d-none');
    }

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    }

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    if (reserves === 'loading') {
        return (
            <Image
                className={`d-block mx-auto`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        );
    }

    if (reserves === 'empty') {
        return (
            <React.Fragment>
                <Box>
                    <Image
                        className={`mb-0 mx-auto`}
                        src={EmptySVG}
                        ms={{
                            display: 'block',
                            width: '120px',
                            height: '120px'
                        }} />
                    <Typography
                        className={`d-block text-center`}
                        component='h2'>
                        لیست رزروهای شما خالی است :(
                    </Typography>
                    <Box
                        className={`my-md`} />
                    <Typography
                        className={`d-block text-center`}
                        component='strong'>
                        هیچ رزروی یافت نشد!
                    </Typography>
                </Box>
            </React.Fragment>
        );
    }

    if (reserves !== 'empty') {
        return (
            <React.Fragment>
                <Grid>
                    {reserves.Data.map((obj, index) => {
                        return (
                            <Grid.Wrapper
                                key={index}
                                className={`parent-class my-lg mt-0 px-xl bg-white border-solid border-light rounded-lg shadow-dark-hover pointer`}>
                                <Grid.Item
                                    size='col-11 lg-3 sm-4'>
                                    <Box
                                        onClick={(event) => extraInfoToggle(event)}
                                        className={`d-flex align-item-center`}>
                                        <Box
                                            className={`mx-lg mr-0`}>
                                            {obj.IsActive &&
                                                <Tooltip
                                                    ms={{
                                                        verticalAlign: 'middle'
                                                    }}>
                                                    <Box
                                                        className={`rounded-circle`}
                                                        ms={{
                                                            width: '12px',
                                                            height: '12px',
                                                            backgroundColor: 'var(--green-medium)'
                                                        }} />
                                                    <Tooltip.Text
                                                        position='top'
                                                        color='white'>
                                                        رزرو فعال
                                                    </Tooltip.Text>
                                                </Tooltip>
                                            }
                                            {!obj.IsActive &&
                                                <Tooltip
                                                    ms={{
                                                        verticalAlign: 'middle'
                                                    }}>
                                                    <Box
                                                        className={`rounded-circle`}
                                                        ms={{
                                                            width: '12px',
                                                            height: '12px',
                                                            backgroundColor: 'var(--gray-light)'
                                                        }} />
                                                    <Tooltip.Text
                                                        position='top'
                                                        color='white'>
                                                        رزرو غیر فعال
                                                    </Tooltip.Text>
                                                </Tooltip>
                                            }
                                        </Box>
                                        <Box>
                                            <Typography
                                                className={`d-block`}
                                                component='strong'>
                                                {obj.HotelName.length <= 20 ? obj.HotelName : (obj.HotelName.substr(0, 20) + '...')}
                                            </Typography>
                                            <Typography
                                                ms={{
                                                    color: '#6F6F7E'
                                                }}>
                                                کد پیگیری :
                                            </Typography> <Typography
                                                ms={{
                                                    color: '#6F6F7E'
                                                }}>
                                                {obj.ReserveId}
                                            </Typography>
                                            {scale === 'x-small' &&
                                                <React.Fragment>
                                                    <Box
                                                        className={`w-100`}>
                                                        مبلغ : <Typography
                                                            className={`text-primary`}
                                                            component='strong'>
                                                            {(Math.floor(obj.Cost) / 10).toLocaleString()} تومان
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        className={`w-100`}>
                                                        <Typography>
                                                            <Badge
                                                                color='primary'>
                                                                <Tooltip>
                                                                    {obj.StatusText.length <= 20 ? obj.StatusText : (obj.StatusText.substr(0, 20) + '...')}
                                                                    <Tooltip.Text
                                                                        position='top'
                                                                        color='primary'>
                                                                        {obj.StatusText}
                                                                    </Tooltip.Text>
                                                                </Tooltip>
                                                            </Badge>
                                                        </Typography>
                                                    </Box>
                                                </React.Fragment>
                                            }
                                        </Box>
                                    </Box>
                                </Grid.Item>
                                {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                                    <React.Fragment>
                                        <Grid.Item
                                            className={`d-flex`}
                                            ms={{
                                                gap: 'var(--sizing-xxl)'
                                            }}
                                            size='col-6'>
                                            <Box>
                                                <Typography
                                                    className={`d-block`}
                                                    component='small'>
                                                    رزرو کننده
                                                </Typography>
                                                <Typography>
                                                    {obj.UserFullName.length <= 15 ? obj.UserFullName : (obj.UserFullName.substr(0, 10) + '...')}
                                                    {obj.AgentFullName === null &&
                                                        <Box
                                                            className={`d-inline-block`}
                                                            component='span'
                                                            ms={{
                                                                width: '16px',
                                                                height: '16px'
                                                            }} />
                                                    }
                                                    <Tooltip>
                                                        {obj.AgentFullName !== null &&
                                                            <Image
                                                                className={`d-inline mx-xs ml-0`}
                                                                src={InfoDarkSVG}
                                                                ms={{
                                                                    width: '16px',
                                                                    height: '16px'
                                                                }} />
                                                        }
                                                        <Tooltip.Text
                                                            position='top'>
                                                            {obj.UserFullName} {obj.AgentFullName !== null &&
                                                                `(${obj.AgentFullName})`
                                                            }
                                                        </Tooltip.Text>
                                                    </Tooltip>
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    className={`d-block`}
                                                    component='small'>
                                                    ثبت رزرو
                                                </Typography>
                                                <Typography>
                                                    {moment.from(obj.InsertDate.split('T')[0]).locale('fa').format('YYYY-MM-DD').replaceAll('-', '/')}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    className={`d-block`}
                                                    component='small'>
                                                    ورود به هتل
                                                </Typography>
                                                <Typography>
                                                    {moment.from(obj.ArrivalDate.split('T')[0]).locale('fa').format('YYYY-MM-DD')}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    className={`d-block`}
                                                    component='small'>
                                                    وضعیت
                                                </Typography>
                                                <Typography>
                                                    <Badge
                                                        color='primary'>
                                                        <Tooltip>
                                                            {obj.StatusText.length <= 20 ? obj.StatusText : (obj.StatusText.substr(0, 20) + '...')}
                                                            <Tooltip.Text
                                                                position='top'
                                                                color='primary'>
                                                                {obj.StatusText}
                                                            </Tooltip.Text>
                                                        </Tooltip>
                                                    </Badge>
                                                </Typography>
                                            </Box>
                                        </Grid.Item>
                                    </React.Fragment>
                                }
                                {(scale === 'medium' || scale === 'small') &&
                                    <React.Fragment>
                                        <Grid.Item
                                            className={`d-flex`}
                                            size='col-7'
                                            ms={{
                                                gap: 'var(--sizing-xl)'
                                            }}>
                                            <Box>
                                                <Typography
                                                    className={`d-block`}
                                                    component='small'>
                                                    رزرو کننده
                                                </Typography>
                                                <Typography>
                                                    {obj.UserFullName.length <= 15 ? obj.UserFullName : (obj.UserFullName.substr(0, 10) + '...')}
                                                    <Tooltip>
                                                        {obj.AgentFullName !== null &&
                                                            <Image
                                                                className={`d-inline mx-xs ml-0`}
                                                                src={InfoDarkSVG}
                                                                ms={{
                                                                    width: '16px',
                                                                    height: '16px'
                                                                }} />
                                                        }
                                                        <Tooltip.Text
                                                            position='top'>
                                                            {obj.UserFullName} {obj.AgentFullName !== null &&
                                                                `(${obj.AgentFullName})`
                                                            }
                                                        </Tooltip.Text>
                                                    </Tooltip>
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    className={`d-block`}
                                                    component='small'>
                                                    وضعیت
                                                </Typography>
                                                <Typography>
                                                    <Badge
                                                        color='primary'>
                                                        <Tooltip>
                                                            {obj.StatusText.length <= 20 ? obj.StatusText : (obj.StatusText.substr(0, 20) + '...')}
                                                            <Tooltip.Text
                                                                position='top'
                                                                color='primary'>
                                                                {obj.StatusText}
                                                            </Tooltip.Text>
                                                        </Tooltip>
                                                    </Badge>
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    className={`d-block`}
                                                    component='small'>
                                                    مبلغ
                                                </Typography>
                                                <Typography
                                                    className={`text-primary`}
                                                    component='strong'>
                                                    {(obj.Cost / 10).toLocaleString()} تومان
                                                </Typography>
                                            </Box>
                                        </Grid.Item>
                                    </React.Fragment>
                                }
                                {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                                    <Grid.Item
                                        size='col-3 lg-2'>
                                        <Typography
                                            className={`d-block`}>
                                            مبلغ
                                        </Typography>
                                        <Typography
                                            className={`text-primary`}
                                            component='strong'>
                                            {(Math.floor(obj.Cost) / 10).toLocaleString()} تومان
                                        </Typography>
                                    </Grid.Item>
                                }
                                {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                                    <Grid.Item
                                        className={`d-flex align-item-center justify-content-end ${Style.reserveDivider} position-relative`}
                                        size='col-1'>
                                        <Image
                                            onClick={() => reserveSource(obj.ReserveId)}
                                            className={`d-inline-block`}
                                            component='img'
                                            src={ObserverSVG}
                                            ms={{
                                                width: '16px',
                                                height: '16px'
                                            }} />
                                        <Box
                                            className={`mx-sm`} />
                                        <Dropdown
                                            ms={{
                                                whiteSpace: 'nowrap'
                                            }}>
                                            <Dropdown.Toggle>
                                                <Image
                                                    className={`d-inline-block`}
                                                    component='img'
                                                    src={VerticalDotsSVG}
                                                    ms={{
                                                        width: '16px',
                                                        height: '16px'
                                                    }} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Body
                                                position='center'
                                                ms={{
                                                    top: '180% !important'
                                                }}>
                                                {obj.OfficialInvoiceStatusId === 0 && obj.StatusId === 101 &&
                                                    <React.Fragment>
                                                        <Typography
                                                            onClick={() => openModal('officalInvoice', obj)}
                                                            component='small'>
                                                            درخواست فاکتور رسمی
                                                        </Typography>
                                                        <Box
                                                            className={`my-sm`} />
                                                    </React.Fragment>
                                                }
                                                {obj.OfficialInvoiceStatusId === 1 &&
                                                    <React.Fragment>
                                                        <Typography
                                                            onClick={() => openModal('officalInvoice', obj)}
                                                            component='small'>
                                                            درخواست فاکتور رسمی (در حال بررسی)
                                                        </Typography>
                                                        <Box
                                                            className={`my-sm`} />
                                                    </React.Fragment>
                                                }
                                                {obj.OfficialInvoiceStatusId === 2 &&
                                                    <React.Fragment>
                                                        <Typography
                                                            onClick={() => officalInvoice(obj.ReserveId)}
                                                            component='small'>
                                                            دانلود فاکتور رسمی
                                                        </Typography>
                                                        <Box
                                                            className={`my-sm`} />
                                                    </React.Fragment>
                                                }
                                                <Typography
                                                    onClick={() => downloadLink('invoice', obj.ReserveId)}
                                                    component='small'>
                                                    دریافت رسید
                                                </Typography>
                                                {obj.StatusId === 101 &&
                                                    <React.Fragment>
                                                        <Box
                                                            className={`my-sm`} />
                                                        <Typography
                                                            onClick={() => downloadLink('voucher', obj.ReserveId)}
                                                            component='small'>
                                                            دریافت واچر
                                                        </Typography>
                                                    </React.Fragment>
                                                }
                                            </Dropdown.Body>
                                        </Dropdown>
                                    </Grid.Item>
                                }
                                {(scale === 'small' || scale === 'x-small') &&
                                    <React.Fragment>
                                        <Grid.Item
                                            className={`d-flex justify-content-end align-item-center`}
                                            size='col-1'>
                                            <Image
                                                onClick={(event) => extraInfoToggle(event)}
                                                src={ChevronDownSVG}
                                                ms={{
                                                    width: '16px',
                                                    height: '16px'
                                                }} />
                                        </Grid.Item>
                                        <Grid.Item
                                            className={`p-0 slide-up`}
                                            size='col-12'>
                                            <Grid>
                                                <Grid.Wrapper>
                                                    <Grid.Item
                                                        size='col-6'>
                                                        <Typography
                                                            className={`d-block`}>
                                                            زمان ثبت
                                                        </Typography>
                                                        <Typography>
                                                            {obj.InsertDate.split('T')[1].split(':')[0]}:{obj.InsertDate.split('T')[1].split(':')[1]} - {moment.from(obj.InsertDate.split('T')[0]).locale('fa').format('YYYY-MM-DD').replaceAll('-', '/')}
                                                        </Typography>
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='col-5'>
                                                        <Typography
                                                            className={`d-block`}>
                                                            ورود به هتل
                                                        </Typography>
                                                        <Typography>
                                                            {moment.from(obj.ArrivalDate.split('T')[0]).locale('fa').format('YYYY-MM-DD')}
                                                        </Typography>
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        className={`d-flex justify-content-center align-item-center`}
                                                        size='col-1'>
                                                        <Image
                                                            onClick={() => reserveSource(obj.ReserveId)}
                                                            className={`d-inline-block`}
                                                            component='img'
                                                            src={ObserverSVG}
                                                            ms={{
                                                                width: '16px',
                                                                height: '16px'
                                                            }} />
                                                        <Box
                                                            className={`mx-sm`} />
                                                        <Dropdown
                                                            ms={{
                                                                whiteSpace: 'nowrap'
                                                            }}>
                                                            <Dropdown.Toggle>
                                                                <Image
                                                                    className={`d-inline-block`}
                                                                    component='img'
                                                                    src={VerticalDotsSVG}
                                                                    ms={{
                                                                        width: '16px',
                                                                        height: '16px'
                                                                    }} />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Body
                                                                position='bottomLeft'
                                                                ms={{
                                                                    top: '180% !important'
                                                                }}>
                                                                {obj.OfficialInvoiceStatusId === 0 && obj.StatusId === 101 &&
                                                                    <React.Fragment>
                                                                        <Typography
                                                                            onClick={() => openModal('officalInvoice', obj)}
                                                                            component='small'>
                                                                            درخواست فاکتور رسمی
                                                                        </Typography>
                                                                        <Box
                                                                            className={`my-sm`} />
                                                                    </React.Fragment>
                                                                }
                                                                {obj.OfficialInvoiceStatusId === 1 &&
                                                                    <React.Fragment>
                                                                        <Typography
                                                                            onClick={() => openModal('officalInvoice', obj)}
                                                                            component='small'>
                                                                            درخواست فاکتور رسمی (در حال بررسی)
                                                                        </Typography>
                                                                        <Box
                                                                            className={`my-sm`} />
                                                                    </React.Fragment>
                                                                }
                                                                {obj.OfficialInvoiceStatusId === 2 &&
                                                                    <React.Fragment>
                                                                        <Typography
                                                                            onClick={() => officalInvoice(obj)}
                                                                            component='small' >
                                                                            دانلود فاکتور رسمی
                                                                        </Typography>
                                                                        <Box
                                                                            className={`my-sm`} />
                                                                    </React.Fragment>
                                                                }
                                                                <Typography
                                                                    onClick={() => downloadLink('invoice', obj.ReserveId)}
                                                                    component='small'>
                                                                    دریافت رسید
                                                                </Typography>
                                                                {obj.StatusId === 101 &&
                                                                    <React.Fragment>
                                                                        <Box
                                                                            className={`my-sm`} />
                                                                        <Typography
                                                                            onClick={() => downloadLink('voucher', obj.ReserveId)}
                                                                            component='small'>
                                                                            دریافت واچر
                                                                        </Typography>
                                                                    </React.Fragment>
                                                                }
                                                            </Dropdown.Body>
                                                        </Dropdown>
                                                    </Grid.Item>
                                                </Grid.Wrapper>
                                            </Grid>
                                        </Grid.Item>
                                    </React.Fragment>
                                }
                            </Grid.Wrapper>
                        )
                    })}
                </Grid>
                <Box
                    className={`d-flex justify-content-center align-item-center`}
                    ms={{
                        gap: '16px'
                    }}>
                    <Button
                        onClick={() => paginationProps(-1)}
                        className={`p-0 rounded-lg`}
                        variant='outlined'
                        color='primary'
                        ms={{
                            width: '30px !important',
                            height: '30px !important',
                            backgroundColor: 'var(--white) !important',
                            borderColor: 'var(--white) !important',
                            boxShadow: 'var(--shadow-dark)'
                        }}>
                        <Image
                            src={PaginationRightSVG} />
                    </Button>
                    <Typography
                        className={`mx-lg text-primary`}>
                        {reserves.PageIndex} / {Math.ceil(reserves.TotalItems / reserves.PageSize)}
                    </Typography>
                    <Button
                        onClick={() => paginationProps(1)}
                        className={`p-0 rounded-lg`}
                        variant='outlined'
                        color='primary'
                        ms={{
                            width: '30px !important',
                            height: '30px !important',
                            backgroundColor: 'var(--white) !important',
                            borderColor: 'var(--white) !important',
                            boxShadow: 'var(--shadow-dark)'
                        }}>
                        <Image
                            src={PaginationLeftSVG} />
                    </Button>
                </Box>
                <Modal
                    className={`officalInvoice`}>
                    <Modal.Wrapper
                        size='xs'
                        ms={{
                            '@media(max-width:576px)': {
                                width: 'calc(100% - 12px) !important'
                            }
                        }}>
                        <Modal.Header
                            className={`border-solid-bottom border-light`}>
                            فاکتور رسمی
                            <Box />
                        </Modal.Header>
                        {selectedReserve.OfficialInvoiceStatusId === 0 &&
                            <React.Fragment>
                                <Box
                                    className={`my-md mt-0 `} />
                                <Typography
                                    className={`px-lg`}>
                                    فاکتور رسمی پس از پایان اقامت شما صادر می شود.
                                </Typography>
                                <Box
                                    className={`p-sm`}
                                    component='form'>
                                    {tabType === 'legalPerson' &&
                                        <React.Fragment>
                                            <Select
                                                onChange={autoFillOfficialInvoice}
                                                label='شرکت‌های ثبت شده'
                                                placeholder='انتخاب شرکت ثبت شده'>
                                                {userCompaniesHistory.map((obj, index) => {
                                                    return (
                                                        <Select.Item
                                                            key={index}
                                                            value={obj.Name}>
                                                            {obj.Name} - {obj.EcoNum}
                                                        </Select.Item>
                                                    );
                                                })}
                                            </Select>
                                            <Box
                                                className={`my-xl mt-0`} />
                                        </React.Fragment>
                                    }
                                    <Box
                                        className={`d-flex justify-content-center`}>
                                        <Typography
                                            onClick={() => toggleTab(false)}
                                            className={`p-sm ${activeTab[0]} rounded-sm pointer`}>
                                            حقیقی
                                        </Typography>
                                        <Box
                                            className={`d-inline-block mx-lg`} />
                                        <Typography
                                            onClick={() => toggleTab(true)}
                                            className={`p-sm ${activeTab[1]} rounded-sm pointer`}>
                                            حقوقی
                                        </Typography>
                                    </Box>
                                    <Box
                                        className={`my-md mb-0 divider-horizontal divider-light`} />
                                    <Grid>
                                        <Grid.Wrapper>
                                            <Grid.Item
                                                size='col-12'>
                                            </Grid.Item>
                                            {tabType === 'naturalPerson' &&
                                                <React.Fragment>
                                                    <Grid.Item
                                                        size='sm-6 col-12'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('name', value)}
                                                            label='نام و نام‌خانوادگی'
                                                            color={addOfficialInvoiceParameters.name.color}
                                                            value={addOfficialInvoiceParameters.name.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-6 col-12'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('codeMelli', value)}
                                                            label='شماره ملی'
                                                            color={addOfficialInvoiceParameters.codeMelli.color}
                                                            value={addOfficialInvoiceParameters.codeMelli.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-6'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('tel', value)}
                                                            label='تلفن'
                                                            color={addOfficialInvoiceParameters.tel.color}
                                                            value={addOfficialInvoiceParameters.tel.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-6'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('mobile', value)}
                                                            label='تلفن همراه'
                                                            color={addOfficialInvoiceParameters.mobile.color}
                                                            value={addOfficialInvoiceParameters.mobile.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='col-4'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('postalCode', value)}
                                                            label='کد پستی'
                                                            color={addOfficialInvoiceParameters.postalCode.color}
                                                            value={addOfficialInvoiceParameters.postalCode.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='col-8'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('postAddress', value)}
                                                            label='نشانی پستی'
                                                            color={addOfficialInvoiceParameters.postAddress.color}
                                                            value={addOfficialInvoiceParameters.postAddress.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        className={`d-flex pb-0`}
                                                        size='col-12 md-6'>
                                                        <Button
                                                            onClick={addOfficialInvoice}
                                                            className={`w-75`}
                                                            variant='filled'
                                                            color='primary'>
                                                            صدور فاکتور رسمی
                                                        </Button>
                                                        <Box
                                                            className={`d-inline-block mx-sm`} />
                                                        <Button
                                                            className={`w-25`}
                                                            onClick={() => closeModal('officalInvoice')}
                                                            variant='outlined'
                                                            color='primary'>
                                                            انصراف
                                                        </Button>
                                                    </Grid.Item>
                                                </React.Fragment>
                                            }
                                            {tabType === 'legalPerson' &&
                                                <React.Fragment>
                                                    <Grid.Item
                                                        size='sm-6 col-12'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('name', value)}
                                                            label='نام و نام‌خانوادگی'
                                                            color={addOfficialInvoiceParameters.name.color}
                                                            value={addOfficialInvoiceParameters.name.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-6 col-6'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('ecoNum', value)}
                                                            label='شماره اقتصادی'
                                                            color={addOfficialInvoiceParameters.ecoNum.color}
                                                            value={addOfficialInvoiceParameters.ecoNum.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-6 col-6'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('codeMelli', value)}
                                                            label='شناسه ملی'
                                                            color={addOfficialInvoiceParameters.codeMelli.color}
                                                            value={addOfficialInvoiceParameters.codeMelli.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-6 col-12'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('regNum', value)}
                                                            label='شماره ثبت'
                                                            color={addOfficialInvoiceParameters.regNum.color}
                                                            value={addOfficialInvoiceParameters.regNum.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-6 col-6'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('tel', value)}
                                                            label='تلفن'
                                                            color={addOfficialInvoiceParameters.tel.color}
                                                            value={addOfficialInvoiceParameters.tel.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-6 col-6'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('mobile', value)}
                                                            label='تلفن همراه'
                                                            color={addOfficialInvoiceParameters.mobile.color}
                                                            value={addOfficialInvoiceParameters.mobile.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-4 col-12'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('postalCode', value)}
                                                            label='کد پستی'
                                                            color={addOfficialInvoiceParameters.postalCode.color}
                                                            value={addOfficialInvoiceParameters.postalCode.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-8 col-12'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('companyAddress', value)}
                                                            label='نشانی'
                                                            color={addOfficialInvoiceParameters.companyAddress.color}
                                                            value={addOfficialInvoiceParameters.companyAddress.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='sm-12 col-12'>
                                                        <TextField
                                                            onChange={(value) => addOfficialInvoiceHandler('postAddress', value)}
                                                            label='نشانی پستی'
                                                            color={addOfficialInvoiceParameters.postAddress.color}
                                                            value={addOfficialInvoiceParameters.postAddress.value} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        className={`d-flex pb-0`}
                                                        size='col-12 md-6'>
                                                        <Button
                                                            onClick={addOfficialInvoice}
                                                            className={`w-75`}
                                                            color='primary'>
                                                            صدور فاکتور رسمی
                                                        </Button>
                                                        <Box
                                                            className={`d-inline-block mx-sm`} />
                                                        <Button
                                                            className={`w-25`}
                                                            onClick={() => closeModal('officalInvoice')}
                                                            variant='outlined'
                                                            color='primary'>
                                                            انصراف
                                                        </Button>
                                                    </Grid.Item>
                                                </React.Fragment>
                                            }
                                        </Grid.Wrapper>
                                    </Grid>
                                </Box>
                            </React.Fragment>
                        }
                        {selectedReserve.OfficialInvoiceStatusId === 1 &&
                            <Typography
                                className={`d-flex align-item-center p-lg pb-0`}>
                                <Image
                                    src={InfoBlueSVG}
                                    ms={{
                                        display: 'inline-block',
                                        width: '30px',
                                        height: '30px',
                                        verticalAlign: 'middle'
                                    }} />
                                <Box
                                    className={`mx-sm mr-0`}
                                    component='span' />
                                درخواست شما برای صدور فاکتور رسمی {selectedReserve.HotelName}، درحال بررسی می باشد.
                            </Typography>
                        }
                    </Modal.Wrapper>
                </Modal>
            </React.Fragment >
        );
    }

}

export default List;